import zhCN from './json/order.zh_CN.json';
import zhTW from './json/order.zh_TW.json';
import en from './json/order.en.json';
import ja from './json/order.ja.json';
import ko from './json/order.ko.json';
import ru from './json/order.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
